/**
 * Dedicated BOGO free-canvas picker page (/pages/bogo-pick).
 */
(function () {
  const root = document.querySelector('[data-bogo-pick-page]');
  if (!root) return;

  const CANVAS_SIZES = [
    'XS',
    'Standard',
    'Mid',
    'Large',
    'Large+',
    'XL',
    'XXL',
    'XXXL',
  ];

  const SIZE_COLLECTION_HANDLES = {
    XS: 'size-xs',
    Standard: 'size-standard',
    Mid: 'size-mid',
    Large: 'size-large',
    'Large+': 'size-large-plus',
    XL: 'size-xl',
    XXL: 'size-xxl',
    XXXL: 'size-xxxl',
  };

  const headerEl = root.querySelector('[data-bogo-pick-header]');
  const successEl = root.querySelector('[data-bogo-pick-success-text]');
  const mediaEl = root.querySelector('[data-bogo-pick-selected-media]');
  const choicesWrapEl = root.querySelector('[data-bogo-pick-choices]');
  const loadingEl = root.querySelector('[data-bogo-pick-loading]');
  const loadingStatusEl = root.querySelector('[data-bogo-pick-loading-status]');
  const loadingBarEl = root.querySelector('[data-bogo-pick-loading-bar]');
  const emptyEl = root.querySelector('[data-bogo-pick-empty]');
  const choicesTitleEl = root.querySelector('[data-bogo-pick-choices-title]');
  const upsellEl = root.querySelector('[data-bogo-pick-upsell]');
  const gridEl = root.querySelector('[data-bogo-pick-grid]');
  const skipCheckoutBtn = root.querySelector('[data-bogo-skip-checkout]');
  const filtersEl = root.querySelector('[data-bogo-pick-filters]');
  const searchInput = filtersEl && filtersEl.querySelector('[data-bogo-pick-search]');
  const sortSelect = filtersEl && filtersEl.querySelector('[data-bogo-pick-sort]');
  const countEl = filtersEl && filtersEl.querySelector('[data-bogo-pick-count]');
  const clearBtn = filtersEl && filtersEl.querySelector('[data-bogo-pick-clear]');

  const GRID_RENDER_CHUNK = 8;
  const GRID_IMAGE_WIDTH = 480;

  let allPicks = [];
  let searchTimer = null;
  let renderGridToken = 0;
  const filterState = {
    color: 'all',
    tex: 'all',
    q: '',
    sort: 'manual',
  };
  const previewRoot = document.querySelector('[data-bogo-pick-preview]');
  const previewImg = previewRoot && previewRoot.querySelector('[data-bogo-preview-img]');
  const previewTitle = previewRoot && previewRoot.querySelector('[data-bogo-preview-title]');
  const previewCounter = previewRoot && previewRoot.querySelector('[data-bogo-preview-counter]');
  const previewPrev = previewRoot && previewRoot.querySelector('[data-bogo-preview-prev]');
  const previewNext = previewRoot && previewRoot.querySelector('[data-bogo-preview-next]');

  let previewImages = [];
  let previewIndex = 0;
  let previewTitleText = '';

  const params = new URLSearchParams(window.location.search);
  const sizeParam = normalizeCanvasSize(params.get('size') || '');
  const variantIdParam = params.get('variant_id') || '';
  const fromCheckout = params.get('bogo_return') === 'checkout';
  const pickRemainingHint = parseInt(params.get('pick') || '0', 10);

  function shopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function catalogHandle() {
    return document.documentElement.dataset.catalogCollection || 'all-in-stock';
  }

  function normalizeCanvasSize(value) {
    const v = String(value || '').trim();
    if (!v) return '';
    if (CANVAS_SIZES.indexOf(v) >= 0) return v;
    const aliases = { L: 'Large', ST: 'Standard', M: 'Mid', 'L+': 'Large+' };
    return aliases[v] || '';
  }

  function escAttr(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function escHtml(value) {
    return escAttr(value);
  }

  function hiResImage(url) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=1400');
    }
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=1400';
  }

  function thumbImageUrl(url, width) {
    const w = width || GRID_IMAGE_WIDTH;
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=' + w);
    }
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  function setLoadingProgress(percent, message) {
    if (loadingStatusEl && message) loadingStatusEl.textContent = message;
    if (loadingBarEl) {
      loadingBarEl.style.width = Math.min(100, Math.max(0, percent)) + '%';
    }
  }

  function setLoadingActive(active) {
    if (choicesWrapEl) {
      choicesWrapEl.classList.toggle('is-loading-choices', active);
      choicesWrapEl.setAttribute('aria-busy', active ? 'true' : 'false');
    }
    if (loadingEl) loadingEl.hidden = !active;
  }

  function productImagesFromJson(product) {
    return (product.images || [])
      .map(function (img) {
        return img && img.src ? img.src : '';
      })
      .filter(Boolean);
  }

  function updatePreviewDialog() {
    if (!previewRoot || !previewImg) return;
    const src = previewImages[previewIndex] || '';
    previewImg.src = hiResImage(src);
    previewImg.alt = previewTitleText;
    if (previewTitle) previewTitle.textContent = previewTitleText;

    const multi = previewImages.length > 1;
    if (previewCounter) {
      previewCounter.hidden = !multi;
      if (multi) {
        previewCounter.textContent = previewIndex + 1 + ' / ' + previewImages.length;
      }
    }
    if (previewPrev) {
      previewPrev.hidden = !multi;
      previewPrev.disabled = previewIndex <= 0;
    }
    if (previewNext) {
      previewNext.hidden = !multi;
      previewNext.disabled = previewIndex >= previewImages.length - 1;
    }
  }

  function openPreview(title, images) {
    if (!previewRoot || !images || !images.length) return;
    previewTitleText = title || '';
    previewImages = images.slice();
    previewIndex = 0;
    updatePreviewDialog();
    previewRoot.hidden = false;
    previewRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bogo-pick-preview-open');
  }

  function closePreview() {
    if (!previewRoot) return;
    previewRoot.hidden = true;
    previewRoot.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bogo-pick-preview-open');
    if (previewImg) previewImg.src = '';
  }

  function bindPreviewDialog() {
    if (!previewRoot) return;

    previewRoot.querySelectorAll('[data-bogo-preview-close]').forEach(function (el) {
      el.addEventListener('click', closePreview);
    });

    if (previewPrev) {
      previewPrev.addEventListener('click', function () {
        if (previewIndex <= 0) return;
        previewIndex -= 1;
        updatePreviewDialog();
      });
    }

    if (previewNext) {
      previewNext.addEventListener('click', function () {
        if (previewIndex >= previewImages.length - 1) return;
        previewIndex += 1;
        updatePreviewDialog();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (previewRoot.hidden) return;
      if (e.key === 'Escape') closePreview();
      if (e.key === 'ArrowLeft' && previewPrev && !previewPrev.disabled) {
        previewPrev.click();
      }
      if (e.key === 'ArrowRight' && previewNext && !previewNext.disabled) {
        previewNext.click();
      }
    });
  }

  function collectionHandleForSize(size) {
    return SIZE_COLLECTION_HANDLES[size] || catalogHandle();
  }

  async function fetchCollectionProducts(handle, onProgress) {
    const base = shopifyRoot().replace(/\/$/, '');
    const products = [];
    let page = 1;

    while (page <= 12) {
      const url =
        base +
        '/collections/' +
        encodeURIComponent(handle) +
        '/products.json?limit=250&page=' +
        page;
      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) {
        if (page === 1) throw new Error('Could not load canvases');
        break;
      }
      const data = await res.json();
      const batch = data.products || [];
      if (!batch.length) break;
      products.push.apply(products, batch);
      if (typeof onProgress === 'function') {
        onProgress({ page: page, count: products.length });
      }
      if (batch.length < 250) break;
      page += 1;
    }
    return products;
  }

  function getOption(product, name) {
    const options = product.options || [];
    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      if (opt && opt.name === name && opt.values && opt.values[0]) {
        return opt.values[0];
      }
    }
    return '';
  }

  function readFilterStateFromUrl() {
    const colorParam = params.get('color');
    if (colorParam) {
      const opts = window.GRAVITY_FILTER_OPTIONS;
      const rawColor = colorParam.toLowerCase();
      filterState.color = opts && opts.parentColor ? opts.parentColor(rawColor) : rawColor;
    } else {
      filterState.color = 'all';
    }
    const texParam = params.get('tex');
    filterState.tex = texParam ? texParam.replace(/ texture$/i, '').trim() : 'all';
    filterState.q = params.get('q') || '';
    filterState.sort = params.get('sort_by') || params.get('sort') || 'manual';
    if (searchInput) searchInput.value = filterState.q;
    if (sortSelect) sortSelect.value = filterState.sort;
  }

  function syncFilterUrl() {
    const url = new URL(window.location.href);
    if (filterState.color !== 'all') url.searchParams.set('color', filterState.color);
    else url.searchParams.delete('color');
    if (filterState.tex !== 'all') url.searchParams.set('tex', filterState.tex);
    else url.searchParams.delete('tex');
    if (filterState.q) url.searchParams.set('q', filterState.q);
    else url.searchParams.delete('q');
    if (filterState.sort && filterState.sort !== 'manual') {
      url.searchParams.set('sort_by', filterState.sort);
    } else {
      url.searchParams.delete('sort_by');
      url.searchParams.delete('sort');
    }
    window.history.replaceState({}, '', url.toString());
  }

  function syncFilterChips() {
    if (!filtersEl) return;
    filtersEl.querySelectorAll('.gravity-shop__chip').forEach(function (chip) {
      const key = chip.getAttribute('data-filter-key');
      const val = chip.getAttribute('data-filter-val');
      chip.setAttribute('aria-pressed', filterState[key] === val ? 'true' : 'false');
    });
  }

  function pickMatches(pick) {
    const opts = window.GRAVITY_FILTER_OPTIONS;
    if (opts && opts.colorMatchesFilter) {
      if (!opts.colorMatchesFilter(pick.color, filterState.color)) return false;
    } else if (filterState.color !== 'all' && pick.color !== filterState.color) {
      return false;
    }
    if (filterState.tex !== 'all' && pick.tex !== filterState.tex) return false;
    if (filterState.q) {
      const hay = [pick.code, pick.title, pick.color, pick.tex]
        .join(' ')
        .toLowerCase();
      if (hay.indexOf(filterState.q.toLowerCase()) === -1) return false;
    }
    return true;
  }

  function sortPicks(list) {
    const sorted = list.slice();
    if (filterState.sort === 'title-ascending') {
      sorted.sort(function (a, b) {
        return a.title.localeCompare(b.title);
      });
    } else if (filterState.sort === 'title-descending') {
      sorted.sort(function (a, b) {
        return b.title.localeCompare(a.title);
      });
    } else if (filterState.sort === 'created-descending') {
      sorted.sort(function (a, b) {
        return String(b.createdAt || '').localeCompare(String(a.createdAt || ''));
      });
    }
    return sorted;
  }

  function updateFilterCount(visible, total) {
    if (!countEl) return;
    const noun = visible === 1 ? 'canvas' : 'canvases';
    if (visible === total) {
      countEl.textContent = visible + ' free ' + noun;
    } else {
      countEl.textContent = visible + ' of ' + total + ' free ' + noun;
    }
  }

  function renderGridChunk(filtered, start, token) {
    if (!gridEl || token !== renderGridToken) return;
    const end = Math.min(start + GRID_RENDER_CHUNK, filtered.length);
    for (let i = start; i < end; i += 1) {
      gridEl.appendChild(renderPickCard(filtered[i], sizeParam));
    }
    if (end < filtered.length) {
      requestAnimationFrame(function () {
        renderGridChunk(filtered, end, token);
      });
    }
  }

  function renderFilteredGrid() {
    if (!gridEl) return;
    const filtered = sortPicks(allPicks.filter(pickMatches));
    syncFilterChips();
    syncFilterUrl();
    updateFilterCount(filtered.length, allPicks.length);

    renderGridToken += 1;
    const token = renderGridToken;
    gridEl.innerHTML = '';
    if (!filtered.length) {
      gridEl.innerHTML =
        '<div class="bogo-pick-page__filter-empty">' +
        '<h3>No canvases match.</h3>' +
        '<p>Try clearing a filter — every piece is one of a kind.</p>' +
        '</div>';
      return;
    }

    renderGridChunk(filtered, 0, token);
  }

  function initFilterChips() {
    const opts = window.GRAVITY_FILTER_OPTIONS;
    if (!opts || !filtersEl) return;
    opts.renderChipRow(
      filtersEl.querySelector('[data-chip-row="color"]'),
      'color',
      opts.colors,
      filterState.color
    );
    opts.renderChipRow(
      filtersEl.querySelector('[data-chip-row="tex"]'),
      'tex',
      opts.textures,
      filterState.tex
    );
  }

  function bindFilters() {
    if (!filtersEl) return;

    initFilterChips();

    filtersEl.querySelectorAll('.gravity-shop__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        const key = chip.getAttribute('data-filter-key');
        const val = chip.getAttribute('data-filter-val');
        if (!key) return;
        filterState[key] = val;
        renderFilteredGrid();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterState.q = searchInput.value.trim();
        clearTimeout(searchTimer);
        searchTimer = setTimeout(renderFilteredGrid, 280);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        filterState.sort = sortSelect.value;
        renderFilteredGrid();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        filterState.color = 'all';
        filterState.tex = 'all';
        filterState.q = '';
        filterState.sort = 'manual';
        if (searchInput) searchInput.value = '';
        if (sortSelect) sortSelect.value = 'manual';
        const url = new URL(window.location.href);
        url.searchParams.delete('color');
        url.searchParams.delete('tex');
        url.searchParams.delete('q');
        url.searchParams.delete('sort_by');
        url.searchParams.delete('sort');
        window.history.replaceState({}, '', url.toString());
        renderFilteredGrid();
      });
    }
  }

  function productSizeFromJson(product) {
    const type = normalizeCanvasSize(product.product_type);
    if (type) return type;
    const options = product.options || [];
    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      if (opt && opt.name === 'Size' && opt.values && opt.values[0]) {
        return normalizeCanvasSize(opt.values[0]);
      }
    }
    const variant = product.variants && product.variants[0];
    if (variant && variant.title && variant.title !== 'Default Title') {
      return normalizeCanvasSize(variant.title.split('/')[0].trim());
    }
    return type;
  }

  function productIdsInCart(cart) {
    const ids = new Set();
    (cart.items || []).forEach(function (item) {
      if (item.product_id != null) ids.add(String(item.product_id));
    });
    return ids;
  }

  function findAnchorInCart(cart, size, variantId) {
    if (
      window.GravityBogoFunnel &&
      window.GravityBogoFunnel.anchorItemForSize
    ) {
      return window.GravityBogoFunnel.anchorItemForSize(cart, size, variantId);
    }
    if (!cart || !cart.items) return null;
    if (variantId) {
      const match = cart.items.find(function (item) {
        return String(item.variant_id) === String(variantId);
      });
      if (match) return match;
    }
    let anchor = null;
    cart.items.forEach(function (item) {
      if (window.GravityBogoFunnel && window.GravityBogoFunnel.canvasSizeFromItem) {
        if (window.GravityBogoFunnel.canvasSizeFromItem(item) !== size) return;
      } else if (normalizeCanvasSize(item.product_type) !== size) {
        return;
      }
      anchor = item;
    });
    return anchor;
  }

  function syncPickPageVariantParam(cart, size) {
    if (
      !window.GravityBogoFunnel ||
      !window.GravityBogoFunnel.pendingSlotForSize
    ) {
      return;
    }
    const slot = window.GravityBogoFunnel.pendingSlotForSize(cart, size);
    if (!slot || !slot.variantId) return;
    if (String(slot.variantId) === String(variantIdParam)) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant_id', slot.variantId);
    window.history.replaceState({}, '', url.toString());
  }

  function renderSelected(anchor, size) {
    if (!headerEl || !successEl || !mediaEl) return;
    const title = anchor.product_title || anchor.title || 'your canvas';
    const image =
      anchor.image ||
      (anchor.featured_image && anchor.featured_image.url) ||
      '';
    successEl.textContent =
      'You have successfully picked out your ' +
      size +
      ' canvas — ' +
      title +
      '.';
    if (image) {
      mediaEl.innerHTML =
        '<button type="button" class="bogo-pick-page__selected-preview" data-bogo-selected-preview>' +
        '<img src="' +
        escAttr(image) +
        '" alt="" width="280" height="373" loading="eager">' +
        '<span class="bogo-pick-page__preview-label">Quick look</span>' +
        '</button>';
      const previewBtn = mediaEl.querySelector('[data-bogo-selected-preview]');
      if (previewBtn) {
        previewBtn.addEventListener('click', function () {
          openPreview(title, [image]);
        });
      }
    } else {
      mediaEl.innerHTML = '';
    }
    headerEl.hidden = false;
  }

  function renderPickCard(pick, size) {
    const card = document.createElement('article');
    const thumbSrc = thumbImageUrl(pick.image, GRID_IMAGE_WIDTH);
    card.className = 'bogo-pick-page__card';
    card.innerHTML =
      '<div class="bogo-pick-page__card-media">' +
      (thumbSrc
        ? '<img src="' +
          escAttr(thumbSrc) +
          '" alt="" loading="lazy" decoding="async" fetchpriority="low" width="240" height="320">'
        : '') +
      '<span class="bogo-pick-page__card-badge">Free with offer</span>' +
      (pick.image
        ? '<button type="button" class="bogo-pick-page__preview-btn" data-bogo-preview-btn>Quick look</button>'
        : '') +
      '</div>' +
      '<div class="bogo-pick-page__card-body">' +
      '<p class="bogo-pick-page__card-name">' +
      escHtml(pick.title) +
      '</p>' +
      '<button type="button" class="btn btn-primary bogo-pick-page__card-add">Get this canvas</button>' +
      '</div>';

    const previewBtn = card.querySelector('[data-bogo-preview-btn]');
    if (previewBtn) {
      previewBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openPreview(pick.title, pick.images && pick.images.length ? pick.images : [pick.image]);
      });
    }

    const addBtn = card.querySelector('.bogo-pick-page__card-add');
    if (addBtn) {
      addBtn.addEventListener('click', async function () {
        addBtn.disabled = true;
        card.classList.add('is-loading');
        try {
          if (!window.GravityCart || !window.GravityCart.addVariant) {
            throw new Error('Cart is unavailable');
          }
          await window.GravityCart.addVariant(pick.variantId, 1, {
            skipBogoPrompt: true,
            skipDrawer: true,
            isCanvas: true,
            properties: {
              _bogo: 'free',
              _canvas_size: sizeParam,
            },
          });

          let cartAfter = null;
          if (window.GravityCart.fetchCart) {
            try {
              cartAfter = await window.GravityCart.fetchCart();
            } catch (fetchErr) {
              /* continue to cart */
            }
          }

          const remaining =
            cartAfter &&
            window.GravityBogoFunnel &&
            window.GravityBogoFunnel.pendingSlotForSize
              ? window.GravityBogoFunnel.pendingSlotForSize(cartAfter, sizeParam)
              : null;

          if (remaining && remaining.count > 0 && !fromCheckout) {
            const nextUrl =
              window.GravityBogoFunnel.pickPageUrl(
                sizeParam,
                remaining.variantId,
                { reason: 'strip' }
              ) +
              '&pick=' +
              encodeURIComponent(String(remaining.count));
            window.location.href = nextUrl;
            return;
          }

          if (fromCheckout) {
            window.location.href = shopifyRoot() + 'checkout';
          } else {
            window.location.href = shopifyRoot() + 'cart';
          }
        } catch (err) {
          alert(err.message || 'Could not add canvas.');
          addBtn.disabled = false;
          card.classList.remove('is-loading');
        }
      });
    }

    return card;
  }

  async function init() {
    if (!sizeParam || CANVAS_SIZES.indexOf(sizeParam) < 0) {
      setLoadingActive(false);
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.textContent = 'This page needs a valid canvas size. Return to the shop and add a backdrop to your bag.';
      }
      return;
    }

    if (fromCheckout && skipCheckoutBtn) {
      skipCheckoutBtn.hidden = false;
    }

    setLoadingActive(true);
    setLoadingProgress(10, 'Checking your bag…');

    const collectionHandle = collectionHandleForSize(sizeParam);
    const productsPromise = fetchCollectionProducts(collectionHandle, function (progress) {
      const pct = Math.min(88, 18 + progress.page * 16);
      const message =
        progress.page === 1
          ? 'Loading free ' + sizeParam + ' canvases…'
          : 'Still loading — page ' + progress.page + ' of the catalogue…';
      setLoadingProgress(pct, message);
    });

    let cart = null;
    if (window.GravityCart && window.GravityCart.fetchCart) {
      try {
        cart = await window.GravityCart.fetchCart();
      } catch (e) {
        /* continue without cart */
      }
    }

    setLoadingProgress(24, 'Loading free ' + sizeParam + ' canvases…');

    const anchor = cart
      ? findAnchorInCart(cart, sizeParam, variantIdParam)
      : null;

    if (cart) {
      syncPickPageVariantParam(cart, sizeParam);
    }

    if (
      cart &&
      window.GravityPackageDiscount &&
      window.GravityPackageDiscount.promotionsExcludeBogo &&
      window.GravityPackageDiscount.promotionsExcludeBogo(cart)
    ) {
      setLoadingActive(false);
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.innerHTML =
          'Buy one, get one free does not apply to studio packages. ' +
          '<a href="' +
          escAttr(shopifyRoot() + 'cart') +
          '">View your bag</a> to continue with package pricing only.';
      }
      return;
    }

    if (anchor) {
      renderSelected(anchor, sizeParam);
    } else if (successEl) {
      successEl.textContent =
        'You have successfully picked out your ' + sizeParam + ' canvas.';
      if (headerEl) headerEl.hidden = false;
    }

    const inCartProducts = cart ? productIdsInCart(cart) : new Set();
    const anchorProductId = anchor && anchor.product_id ? String(anchor.product_id) : '';

    let products = [];
    try {
      products = await productsPromise;
      setLoadingProgress(92, 'Almost ready — sorting your options…');
    } catch (err) {
      setLoadingActive(false);
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.textContent = err.message || 'Could not load canvases.';
      }
      return;
    }

    const picks = [];
    products.forEach(function (product) {
      if (productSizeFromJson(product) !== sizeParam) return;
      if (!product.variants || !product.variants.length) return;
      if (inCartProducts.has(String(product.id)) && String(product.id) !== anchorProductId) {
        return;
      }
      if (anchorProductId && String(product.id) === anchorProductId) return;

      const variant = product.variants.find(function (v) {
        return v.available;
      });
      if (!variant) return;

      const images = productImagesFromJson(product);
      const colorRaw = getOption(product, 'Color') || '';
      const texRaw = getOption(product, 'Texture') || '';
      picks.push({
        id: product.id,
        title: product.title,
        code: (product.title || '').split(' ')[0] || '',
        color: colorRaw.toLowerCase(),
        tex: texRaw.replace(/ texture$/i, '').trim(),
        createdAt: product.created_at || '',
        image: images[0] || '',
        images: images,
        variantId: variant.id,
      });
    });

    setLoadingProgress(100, 'Ready');
    setLoadingActive(false);

    if (!picks.length) {
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.innerHTML =
          'No other in-stock ' +
          escHtml(sizeParam) +
          ' canvases are available right now. <a href="' +
          escAttr(shopifyRoot() + 'cart') +
          '">View your bag</a> or browse the full catalogue.';
      }
      return;
    }

    if (choicesTitleEl) {
      choicesTitleEl.hidden = false;
      const slot =
        cart &&
        window.GravityBogoFunnel &&
        window.GravityBogoFunnel.pendingSlotForSize
          ? window.GravityBogoFunnel.pendingSlotForSize(cart, sizeParam)
          : null;
      const remaining = pickRemainingHint || (slot && slot.count) || 1;
      if (remaining > 1) {
        choicesTitleEl.textContent =
          'Pick your free ' + sizeParam + ' canvases (' + remaining + ' remaining)';
      } else if (slot && slot.paidCount > 1) {
        choicesTitleEl.textContent =
          'Pick your next free ' + sizeParam + ' canvas';
      } else {
        choicesTitleEl.textContent = 'Pick your free ' + sizeParam + ' canvas';
      }

      if (upsellEl) {
        upsellEl.hidden = true;
        upsellEl.innerHTML = '';
      }
    }

    allPicks = picks;
    readFilterStateFromUrl();
    if (filtersEl) filtersEl.hidden = false;
    renderFilteredGrid();
  }

  bindPreviewDialog();
  bindFilters();
  init();
})();
